import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { UserHead } from '../../StyledComponents'
import Avatar from "@components/avatar"
import avatarUrl from '../../assets/images/portrait/small/avatar-s-11.jpg'
import location from '../../assets/images/icons/location.svg'
import card from '../../assets/images/icons/credit-card.svg'
import { useDispatch, useSelector } from 'react-redux'
import { Loader } from 'react-feather'
import { toFormatDateWOTime } from '../../snippets/snippets'
import ManageTable from '../Manage/ManageTable'
import Action from '../../redux/Action'
import { getDashboardData } from '../../utility/api/services/UserPortal/UserSlice'

const UserDashboard = () => {

  const name = 'Orders'

  const dispatch = useDispatch()

  // const charityData = useSelector(state=>state.user.usersData)

  const { isLoading, userDashboard, error } = useSelector((state) => state.userPortal);

  const [showEditModal, setShowEditModal] = useState(false)
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const [tableData, setTableData] = useState([])
  const [userData, setUserData] = useState([])
  const [isUpdated, setIsUpdated] = useState(false)
  const [updatedData, setUpdatedData] = useState([])

  const clickHandler = (data, name) => {
    setShowEditModal(true)
    // setOpenName(name)
    setData(data)
  }

  // useEffect(()=> {
  //   dispatch(getDashboardData());
  // }, [dispatch]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  const getData = () => {
    dispatch(getDashboardData());
    setLoading(false)
  }


  useEffect(() => {
    setLoading(true)
        if(userDashboard.length==0){
            getData()
        }
  }, [])

  // useEffect(() => {
  // const intervalId = setInterval(() => {
  //   getData();
  // }, 15000); // Call getData every 2 minutes (180000 milliseconds)

  // return () => clearInterval(intervalId); // Cleanup on unmount or re-render
  // }, []);

  useEffect(()=>{

    if(userDashboard.length!=0){
        setUserData(userDashboard?.data)
        setLoading(false)
    }
  },[userDashboard])

  const data11 = [
    {
      header: "Personal Info.",
      image: avatarUrl,
      name: "Your Name",
      email: "Loremipsum@gmail.com",
    },
    {
      header: "Address Book",
      image: location,
      address: "Street no. 3, Madina Town, Faisalabad Faisalabad, 38860",
      country: "Pakistan",
      phone: "03234567890",
    },
    {
      header: "Billing Address",
      image: card,
      address: "Street no. 3, Madina Town, Faisalabad Faisalabad, 38860",
      country: "Pakistan",
      phone: "03234567890",
    },
  ];

  const mockTableData = [
    {
      sn: 1,
      product_name: "Product 1",
      seller_name: "Seller A",
      address: "Street no. 1, City A, Country A",
      p_date: new Date().toISOString(), // Use current date for placement date
      price: "$100",
      a_date: new Date(Date.now() + 86400000).toISOString(), // Arrival date is 1 day later
      status: "Delivered",
      p_status: "Paid",
    },
    {
      sn: 2,
      product_name: "Product 2",
      seller_name: "Seller B",
      address: "Street no. 2, City B, Country B",
      p_date: new Date(Date.now() - 86400000).toISOString(), // Use yesterday's date
      price: "$150",
      a_date: new Date(Date.now() + 172800000).toISOString(), // Arrival date is 2 days later
      status: "In Transit",
      p_status: "Pending",
    },
    {
      sn: 3,
      product_name: "Product 3",
      seller_name: "Seller C",
      address: "Street no. 3, City C, Country C",
      p_date: new Date(Date.now() - 43200000).toISOString(), // Use half a day ago
      price: "$200",
      a_date: new Date(Date.now() + 259200000).toISOString(), // Arrival date is 3 days later
      status: "Cancelled",
      p_status: "Refunded",
    },
  ];
  

  useEffect(() => {
    // Simulate fetching data
    setTableData(mockTableData);
    setLoading(false);
  }, []);


  const columns = [
    //   {
    //       name: "Flag",
    //       cell:(row) => (<div
    //           // onClick={() => {
    //           //     setshowModal(true)
    //           //     setUpdateModal(row.image !== "" ? row.image : 'https://i.stack.imgur.com/y9DpT.jpg')
    //           // }}
    //            style={{width:"100%", padding:'0px', margin:'0px'}}>
    //               <img src={ row.profile_image == "" || row.profile_image == "undefined" || row.profile_image == undefined || row.profile_image == null || row.profile_image == "null" ? 'https://i.stack.imgur.com/y9DpT.jpg' :getImageUrl(row.profile_image) } 
    //                       style={{borderRadius:"50%", height:"35px", width:"35px"}} />
    //           </div>),
    //           width:'80px',
    //   },
    {
      name: "Product",
      cell: (row) => <span title={row.product_name} className="ellipsis">{row.product_name}</span>,
      selector:(row) => row.product_name,
      sortable: true,
      // center: true
    },
    {
      name: "Seller",
      cell: (row) => <span title={row.seller_name} className="ellipsis">{row.seller_name}</span>,
      selector:(row) => row.seller_name,
      sortable: true,
      // center: true
    },
    {
      name: "Address",
      cell: (row) => <span title={row.address} className="ellipsis">{row.address}</span>,
      selector:(row) => row.address,
      sortable: true,
      // center: true
    },
    {
      name: "Placement Date",
      cell: (row) => <span title={toFormatDateWOTime(row.p_date)} className="ellipsis">{toFormatDateWOTime(row.p_date)}</span>,
      selector:(row) => row.p_date,
      sortable: true,
      // center: true
    },

    {
      name: "Price",
      cell: (row) => <span title={row.price} className="ellipsis">{row.price}</span>,
      selector:(row) => row.price,
      sortable: true,
      // center: true
    },
    {
      name: "Arrival Date",
      cell: (row) => <span title={toFormatDateWOTime(row.a_date)} className="ellipsis">{toFormatDateWOTime(row.a_date)}</span>,
      selector:(row) => row.a_date,
      sortable: true,
      // center: true
    },
    {
      name: "Status",
      cell: (row) => <span title={row.status} className="ellipsis">{row.status}</span>,
      selector:(row) => row.status,
      sortable: true,
      // center: true
    },
    {
      name: "Payment",
      cell: (row) => <span title={row.p_status} className="ellipsis">{row.p_status}</span>,
      selector:(row) => row.p_status,
      sortable: true,
      // center: true
    },

  ]


  const joinAddress = (address) => {
    const { street, apartment, city, zipCode, country, phone } = address || {};
    return [street, apartment, city, zipCode, country].filter(Boolean).join(', ') + (phone ? `\nPhone no. ${phone}` : '');
  };


  return (
    <>
    {console.log('userDashboard', userData, userDashboard)}
      <div className='p-3 w-100'>
      <Row className="g-2 h-100" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {!isLoading && userDashboard ? (
            <>
              <Col xs={12} md={4}>
                <div style={{ border: '1px solid #D9D9D9', borderRadius: '20px', padding: '0.5rem', margin: '0.5rem', height: '100%' }}>
                  <UserHead>Personal Info.</UserHead>
                  <div className='d-flex justify-content-center p-2'>
                    <img
                      src={userData?.image || avatarUrl}
                      height="137"
                      width="137"
                      style={{ borderRadius: '50%' }}
                    />
                  </div>
                  <div className='p-2'>
                    <div>{`${userData?.firstName} ${userData?.lastName}`}</div>
                    <div>{userData?.email}</div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div style={{ border: '1px solid #D9D9D9', borderRadius: '20px', padding: '0.5rem', margin: '0.5rem', height: '100%' }}>
                  <UserHead>Address Book</UserHead>
                  <div className='d-flex justify-content-center p-2'>
                    <img
                      src={location}
                      height="115"
                      width="115"
                    />
                  </div>
                  <div className='p-2'>
                  <div>{joinAddress(userData?.address?.defaultDeliveryAddress)}</div>
                    {/* <div>{`${userData?.address?.defaultDeliveryAddress?.street || '-'}, ${userData?.address?.defaultDeliveryAddress?.apartment || '-'}, ${userData?.address?.defaultDeliveryAddress?.city || '-'}, ${userData?.address?.defaultDeliveryAddress?.zipCode || '-'}`}</div>
                    <div>{userData?.address?.defaultDeliveryAddress?.country || '-'}</div> */}
                    <div>
                      <span>Phone no.</span> <span>{userData?.address?.defaultDeliveryAddress?.phone || '-'}</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div style={{ border: '1px solid #D9D9D9', borderRadius: '20px', padding: '0.5rem', margin: '0.5rem', height: '100%' }}>
                  <UserHead>Billing Address</UserHead>
                  <div className='d-flex justify-content-center p-2'>
                    <img
                      src={card}
                      height="115"
                      width="115"
                    />
                  </div>
                  <div className='p-2'>
                    <div>{joinAddress(userData?.address?.defaultBillingAddress)}</div>
                    {/* <div>{`${userData?.address?.defaultBillingAddress?.street || ''}, ${userData?.address?.defaultBillingAddress?.apartment || ''}, ${userData?.address?.defaultBillingAddress?.city || ''}, ${userData?.address?.defaultBillingAddress?.zipCode || ''}`}</div>
                    <div>{userData?.address?.defaultBillingAddress?.country}</div> */}
                    <div>
                      <span>Phone no.</span> <span>{userData?.address?.defaultBillingAddress?.phone || '-'}</span>
                    </div>
                  </div>
                </div>
              </Col>
            </> 
          ): ''
        }
        </Row>

        <div className='py-4'>Recent Orders</div>
        {loading ? <Loader /> :
          <ManageTable
            name={name}
            // can_create={childPageData.can_create}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }

      </div>

    </>
  )
}

export default UserDashboard
